module.exports = __webpack_public_path__ + "img/arowana.b89eed8c.png";